import dayjs from 'dayjs';
import stringToDate from '../../../utils/stringToDate';

const AVAILABILITY_KEY_FORMAT = 'YYYY-MM-DD';

/** Parse a date string in `dateFormat` back to a Date object. */
export const toDate = (str, dateFormat) => (str ? stringToDate(str, dateFormat) : null);

/** Format a Date as the externally-shaped date string (dayjs uses upper-cased tokens). */
export const toDateString = (date, dateFormat) => (
  date ? dayjs(date).format(dateFormat.toUpperCase()) : ''
);

/** Normalize a Date (or null) to local midnight. */
export const atDayStart = date => (
  date ? dayjs(date).startOf('day').toDate() : null
);

/** Format a Date as YYYY-MM-DD - the availability map key format. */
export const toAvailabilityKey = date => (
  date ? dayjs(date).format(AVAILABILITY_KEY_FORMAT) : null
);
